
import wx from 'weixin-js-sdk';
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Group from 'vux/src/components/group/index.vue'


export default {
name: 'clothesFactoryConfirmInfo',
components: {
wx,XTextarea,Group
},
data () {
return {
id:0,
code:0,
info:{
pics_path:[],
img_path:[],
audios:[],
},
currentIndex:0,
popUp:false,
videoShow:false,
srcAudio:'',
srcAudioText:'',
popBg:false,
popContent:false,
content:'',
grade:0,
}
},
created(){
},
mounted(){
this.id = this.$route.params.id;
this.code = this.$route.params.code;
if(this.id){
this.getOrder();
}
},
methods:{
editContent(){
this.content = this.info.content;
this.popBg = true;
this.popContent = true;
},
searchOrder(orderNo){
this.$router.push({name:'searchOrder',params:{code:orderNo}})
},
barOrder(code){
this.$router.push({name:'barOrder',params:{code:code}})
},
copy(val){
this.$func.copy(val,event);
},
showPic(urls,url){
wx.previewImage({
current: url ? url : urls[0], // 当前显示图片的 http 链接
urls: urls 
});
},
getOrder(){
let that = this;
if(!this.id){
that.$func.showToast('数据错误，请确认后再试');
return ;
}
that.$func.startLoading();
this.$api.clothesFactoryConfirmInfo({id:this.id,code:this.code}).then((res)=>{
if(res){
that.info = res.data;
that.$func.endLoading();
}
})
},
submitContent(){
let that = this;
if(!this.id){
that.$func.showToast('数据错误，请确认后再试');
return ;
}
this.$func.confirm('确认提交？','提示',()=>{
that.$api.submitClothesConfirmContent({id:that.id,content:that.content}).then((res)=>{
if(res){
that.$func.showToast('已提交');
that.closePop();
that.getOrder();
}
})
})
},

startPlaying(i){
this.currentIndex = i;
this.popUp = true;
this.videoShow = true;
this.srcAudio = this.info.audios_path.length > 0 ? this.info.audios_path[this.currentIndex] : '';
this.srcAudioText = (this.currentIndex+1) +'、'+this.srcAudio.substr(this.srcAudio.lastIndexOf('/')+1,20);
this.playAudio();
},

playAudio() {
const that = this;
wx.ready(function () {
let media = document.getElementById("musicBox");
media.src = that.srcAudio;
media.play();
});
},

playNextAudio() {
this.currentIndex++;
if (this.currentIndex < this.info.audios_path.length) {
this.srcAudio = this.info.audios_path.length > 0 ? this.info.audios_path[this.currentIndex] : '';
this.srcAudioText = (this.currentIndex+1) +'、'+this.srcAudio.substr(this.srcAudio.lastIndexOf('/')+1,20);

this.playAudio();
} else {

this.srcAudioText = '';
this.closePop();
console.log('All audios finished playing');
}
},
closePop(){
this.popUp = false;
this.videoShow = false;
this.popBg = false;
this.popContent = false;
wx.ready(function () {
let media = document.getElementById("musicBox");
media.pause();
});
},
submitPush(){
let that = this;
if(!this.id){
that.$func.showToast('数据错误，请确认后再试');
return ;
}
this.$func.confirm('确认通知门店？','提示',()=>{
that.$api.submitClothesConfirmPush({id:that.id}).then((res)=>{
if(res){
that.$func.showToast('已提交');
that.getOrder();
}
})
})
},
submit(e){
let that = this;
if(!this.id){
that.$func.showToast('数据错误，请确认后再试');
return ;
}
this.$func.confirm('确认提交？','提示',()=>{
that.$api.submitClothesConfirm({id:that.id,result:e}).then((res)=>{
if(res){
that.$func.showToast('已提交');
that.getOrder();
}
})
})
}
}
}



// WEBPACK FOOTER //
// ./src/pages/clothesFactoryConfirmInfo.vue